"use strict";
module.exports = {
    'name': 'English',
    'code': 'en',
    'greeting': 'hello',
    'drag & drop': 'drag & drop',
    'or click here to browse': 'or click here to browse',
    'follow': 'Follow',
    'following': 'Following',
    'explore tracks': 'Explore tracks',
    'create your own': 'Create your own',
    'activities': {
        'Cycle': 'Cycle',
        'Mountain Bike': 'Mountain Bike',
        'Motorcycle': 'Motorcycle',
        'Dirt Bike': 'Dirt Bike',
        'Car': 'Car',
        'Drive': 'Drive',
        'Train': 'Train',
        'Equestrian': 'Equestrian',
        'Camel': 'Camel',
        'Horse Riding': 'Horse Riding',
        'Run': 'Run',
        'Trail Run': 'Trail Run',
        'XC Ski': 'XC Ski',
        'Snowboard': 'Snowboard',
        'Ski': 'Ski',
        'Snowmobile': 'Snowmobile',
        'Snowshoe': 'Snowshoe',
        'Climb': 'Climb',
        'Mountaineer': 'Mountaineer',
        'Hike': 'Hike',
        'Walk': 'Walk',
        'Trek': 'Trek',
        'Paddle': 'Paddle',
        'Kayak': 'Kayak',
        'Canoe': 'Canoe',
        'Row': 'Row',
        'Motor Boat': 'Motor Boat',
        'Sailing': 'Sailing',
        'Waterski': 'Waterski',
        'Wakeboard': 'Wakeboard',
        'Kitesurf': 'Kitesurf',
        'Surf': 'Surf',
        'Windsurf': 'Windsurf',
        'Swim': 'Swim',
        'Airplane': 'Airplane',
        'Balloon': 'Balloon',
        'Birds': 'Birds',
        'Aviary': 'Aviary',
        'Hang Glide': 'Hang Glide',
        'Paraglide': 'Paraglide',
        'Sailplane': 'Sailplane',
        'Glide': 'Glide',
        'Drone': 'Drone',
        'UAV': 'UAV',
        'Aerial': 'Aerial',
        'Ground': 'Ground',
        'Mixed': 'Mixed',
        'Hike + Glide': 'Hike + Glide',
        'Other': 'Other',
    },
};
